import { render, staticRenderFns } from "./MTextAreaComp.vue?vue&type=template&id=149c333a&"
import script from "./MTextAreaComp.vue?vue&type=script&lang=js&"
export * from "./MTextAreaComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports